// Views of the shared leads list (LeadsList). A view is data only: which
// records it shows (scopeQuery), its columns, its sort and its words.
// LeadsList must not branch on the view's id; every difference between
// views lives here.

const LEADS_COLUMNS = ['name', 'company', 'email', 'phone', 'companyPhone', 'website', 'status', 'priority', 'source', 'date', 'value', 'owner'];

export const LEAD_VIEWS = {
  leads: {
    id: 'leads',
    title: 'Leads',
    noun: { one: 'lead', many: 'leads' },
    // Won leads live under Customers and Do Not Call under its own page,
    // unless the URL asks for a status explicitly (deep links, reports).
    scopeQuery: (q) => (q.status ? q : { ...q, excludeStatus: 'won,do_not_call' }),
    defaultSort: { sortBy: 'createdAt', sortOrder: 'desc' },
    storageKey: 'leadsListColumns',
    columns: {
      available: LEADS_COLUMNS,
      defaults: {
        name: true,
        company: true,
        email: false,
        phone: true,
        companyPhone: false,
        website: false,
        status: true,
        priority: true,
        source: false,
        date: false,
        value: false,
        owner: true,
      },
    },
    // Stage filter options: Won stages belong to Customers, Do Not Call
    // stages to /do-not-call.
    stageOptions: (stage) => stage.closedType !== 'won' && stage.closedType !== 'do_not_call',
    createLink: '/leads/new',
    emptyState: {
      zeroData: { title: 'No leads yet', hint: 'New leads from your forms, ads, calls and messages appear here.' },
      zeroMatch: { title: 'No leads match your filters' },
    },
    linkBase: '/leads',
  },

  customers: {
    id: 'customers',
    title: 'Customers',
    noun: { one: 'customer', many: 'customers' },
    // Won leads, defined on the server (scope=customers): a status in the
    // URL cannot widen it. status=won is sent too, so a backend that does
    // not know the scope yet (a half-finished deploy) still lists only
    // won leads instead of every lead.
    scopeQuery: (q) => {
      const { status, excludeStatus, ...rest } = q;
      return { ...rest, status: 'won', scope: 'customers' };
    },
    // URL keys this view ignores (old bookmarks may carry ?status=).
    ignoredFilters: ['status'],
    defaultSort: { sortBy: 'wonAt', sortOrder: 'desc' },
    // Won-date range (dashboard "Won this month" links here with it).
    extraFilters: ['wonFrom', 'wonTo'],
    storageKey: 'customersListColumns',
    columns: {
      // No Status column: changing the stage from here would silently drop
      // the row. Reopening a customer happens on the lead page or the board.
      available: ['name', 'phone', 'email', 'company', 'wonAt', 'value', 'attribution', 'opendental', 'owner', 'priority', 'date'],
      defaults: {
        name: true,
        phone: true,
        email: false,
        company: false,
        wonAt: true,
        value: true,
        attribution: true,
        opendental: true,
        owner: true,
        priority: false,
        date: false,
      },
      // Phones show name and phone; won date and OpenDental from md.
      hideBelow: { wonAt: 'md', opendental: 'md', value: 'lg', attribution: 'lg', owner: 'lg', email: 'lg', company: 'lg', priority: 'lg', date: 'lg' },
    },
    stageOptions: (stage) => stage.closedType === 'won',
    createLink: null,
    emptyState: {
      zeroData: { title: 'No customers yet', hint: 'Move a lead to a Won stage to see it here.' },
      zeroMatch: { title: 'No customers match your filters' },
    },
    linkBase: '/customers',
  },
};
